/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import styled from 'styled-components';
import {Collapsible, FontSizes, FontWeights, Text, minWidth} from '@calm-web/design-system';
import {FaqItem} from '../../../homepageRefresh/homepage/FAQ/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ol: "ol",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(FaqItem, {
      $hideBorder: true,
      triggerTextColor: "bannerText",
      trigger: 'How do I know if I have anxiety?',
      children: _jsx(_components.p, {
        children: "It's important to acknowledge that occasional anxiety is a normal part of life, and anxiety can manifest\nitself in various ways. Some symptoms of anxiety include: excessive worry, fatigue (even without engaging in\nstrenuous activities), sleep disturbances, irritability, restlessness, or having difficulty staying calm.\nIt's also important to note that self-diagnosis for anxiety is not a substitute for professional guidance.\nIf you believe you have a more severe form of anxiety, we recommend you consult with a healthcare\nprofessional."
      })
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I get rid of stress?',
      children: [_jsx(_components.p, {
        children: "If you need stress relief, here are a few things to try:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Move your body. Engaging in physical activity helps reduce stress levels and can improve your mood. Try the ", _jsx(_components.a, {
            href: "/app/player/GCmP071jiL",
            children: "Daily Move in the Calm app"
          }), " for short, gentle movement videos that can help you relax and get out of your head"]
        }), "\n", _jsxs(_components.li, {
          children: ["Meditate. While meditation can seem intimidating at first, it's highly effective for your emotional wellbeing and can help you focus your attention and quiet the mind. We recommend starting with the ", _jsx(_components.a, {
            href: "/app/program/mVcvqWcR8C",
            children: "Mindfulness for Beginners course with Jeff Warren"
          }), ", or one of our ", _jsx(_components.a, {
            href: "/app/program/gy2hJS2oth",
            children: "Quick Meditations"
          }), ", which are only 2 to 3 minutes long."]
        }), "\n", _jsxs(_components.li, {
          children: ["Breathe. Deep breathing exercises, like ", _jsx(_components.a, {
            href: "/app/program/yW8jU5t6LC",
            children: "this"
          }), " or ", _jsx(_components.a, {
            href: "/app/program/fsRlMMWEkx",
            children: "this"
          }), ", can help ground your attention in the present moment, restoring a sense of stability during stressful situations."]
        }), "\n", _jsxs(_components.li, {
          children: ["Listen to music. Music can help quiet the mind and ease tension, helping soothe the day's stressors. We recommend this ", _jsx(_components.a, {
            href: "/app/program/DTmi0jbVmd",
            children: "classical playlist"
          }), " designed to relieve stress."]
        }), "\n"]
      })]
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How does stress affect the body?',
      children: _jsxs(_components.p, {
        children: ["Stress is an inevitable part of our lives, and understanding its effects on the body is the first step\ntoward managing it. In times of stress, your digestive, immune, cardiovascular, muscular and respiratory\nsystems can all be impacted. From breathing patterns to muscle tension, stomachaches to an increased heart\nrate, stress can affect you head to toe. Stress and its effect on your body can be mitigated.\n", _jsx(_components.a, {
          href: "/app/player/GCmP071jiL",
          children: "Movement"
        }), ", ", _jsx(_components.a, {
          href: "/app/program/yW8jU5t6LC",
          children: "breathwork"
        }), "\nand ", _jsx(_components.a, {
          href: "/app/program/4epnASwLVS",
          children: "meditation"
        }), " can help ease your body's response to stress. And\ncreating a regular mindfulness practice can equip you with personalized tools to combat any future\nstressors."]
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What causes social anxiety?',
      children: _jsx(_components.p, {
        children: "Social anxiety is much more common than you might realize. It can be caused by a range of factors, such as\ngenetic predisposition, past traumatic experiences, a lack of social support, highly critical self-talk, or\nperfectionism."
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is stress?',
      children: _jsx(_components.p, {
        children: "Stress is a very common and human experience. It can be defined as a natural response to a perceived threat,\ndemand, or challenge. It is a physiological and psychological reaction that prepares the body and mind to\ncope with the situation at hand. While stress is a normal part of life, excessive or chronic stress can be\noverwhelming and impair your overall well-being."
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is an anxiety attack?',
      children: _jsx(_components.p, {
        children: "Anxiety attacks, also known as panic attacks, can be overwhelming experiences. They are brief episodes of\nintense fear and discomfort. An attack can start quickly and unexpectedly. Symptoms can range from physical\nto mental to emotional. They include intense feelings of fear, a sense of losing control, a sense of\nimpending doom, a pounding or racing heart, shortness of breath, chest pain, dizziness, trembling or\nshaking, sweating, hot flashes or chills, nausea, or stomach discomfort."
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I stop an anxiety attack?',
      children: _jsxs(_components.p, {
        children: ["Anxiety attacks can be intense, distressing, and disruptive. But there are preemptive measures that can be\ntaken. This grounding meditation by ", _jsx(_components.a, {
          href: "/app/program/_kCx96PwDb",
          children: "Tamara Levitt"
        }), " can help soften\nthe start of a strong wave of emotions. This exercise by ", _jsx(_components.a, {
          href: "/app/program/cIHZnEBSWD%5D",
          children: "Jay\nShetty"
        }), " can help stop the thought spirals that could trigger an\nattack. When in doubt, call out different smells, sounds, and feelings to help steady the breath and bring\nyou back to the present moment."]
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I calm anxiety?',
      children: _jsx(_components.p, {
        children: "Calming anxiety requires a highly personal approach. A solid first step is to deepen your understanding of\nyour mind and body, in order to find tools that work best for you. Meditation for beginners, gentle\nmovement, and seeking out the help of a professional are all good ways to start."
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: "What's the best meditation for anxiety?",
      children: _jsx(_components.p, {
        children: "There are a variety of factors that go into answering this question. A good starting point is to reflect on\nwhat might be causing your anxiety. If your symptoms are physical, carving out 7 minutes of mindful movement\ncould help ease any tightness or jitters living in the body. If your symptoms are more emotional, sitting in\nstillness as a soundscape plays can help soothe the mind. Reminding yourself to remain gentle and\ncompassionate can also help when your mind or body tries to initially resist these practices, especially if\nyou're just starting out."
      })
    }), "\n", _jsx(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: "What's the most effective tool for stress relief?",
      children: _jsxs(_components.p, {
        children: ["Finding the tools that work best for you is highly personal, and can be an ongoing process. Grant yourself\nthe grace to try out new practices. Patience and compassion are essential. A great place to start is\nbuilding a consistent sleep habit. ", _jsx(_components.a, {
          href: "/app/player/2QQEAZ7IsG",
          children: "Sleep Stories"
        }), " can help you fall (and stay!) asleep so that you're primed\nto take on any surprises the following day. Another effective tool is meditation, which we've made simple\nand approachable. ", _jsx(_components.a, {
          href: "/app/program/mVcvqWcR8C",
          children: "Jeff Warren's series"
        }), " is a fan favorite."]
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
